export const css = {
	root: '_32fujPZn',
	listItem: '_18MPRvlL',
	' _key': 'apic-theme/dojo/breadcrumb-group'
};

export default css;
